import React from 'react';
import { useSelector } from 'react-redux';

import { getMarket } from '@travel/i18n';
import {
  RTTaiwanBrandHorizontal,
  RTTaiwanBrandVertical,
  TravelLogoHorizontal,
  TravelLogoVertical,
} from '@travel/icons/ui';

import useDeviceType from '../../utils/useDeviceType';

import cx from '../../utils/classnames';

import styles from './travelLogo.module.scss';

type Props = {
  /** String of color code */
  color?: string;
  className?: string;
  isWide?: boolean;
  isSP?: boolean;
  isTWNMarket?: boolean;
};

function SmallTravelLogo(props: Props) {
  const { color, isTWNMarket, ...restProps } = props;

  const IconComponent = isTWNMarket ? RTTaiwanBrandVertical : TravelLogoVertical;

  return (
    <IconComponent
      className={cx(color === 'white' && styles.white)}
      data-testid="smallTravelLogo"
      {...restProps}
    />
  );
}

function WideTravelLogo(props: Props) {
  const { color, isSP: _isSP, isTWNMarket, ...restProps } = props;

  const IconComponent = isTWNMarket ? RTTaiwanBrandHorizontal : TravelLogoHorizontal;

  return (
    <IconComponent
      className={cx(color === 'white' && styles.white)}
      data-testid="wideTravelLogo"
      {...restProps}
    />
  );
}

function TravelLogo(props: Props) {
  const deviceType = useDeviceType();
  const market = useSelector(getMarket)?.marketCode || '';

  const isSP = deviceType === 'sp';
  const isTWNMarket = market === 'TWN';

  if (isSP && !props.isWide) return <SmallTravelLogo {...props} isTWNMarket={isTWNMarket} />;
  return <WideTravelLogo isSP={isSP} {...props} isTWNMarket={isTWNMarket} />;
}

export default TravelLogo;
